import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckBoxOutlineBlank = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-273.78 -348.44 1955.56 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1120 1280H288Q222 1280 175.0 1233.0Q128 1186 128 1120V288Q128 222 175.0 175.0Q222 128 288 128H1120Q1186 128 1233.0 175.0Q1280 222 1280 288V1120Q1280 1186 1233.0 1233.0Q1186 1280 1120 1280ZM1408 1120V288Q1408 169 1323.5 84.5Q1239 0 1120 0H288Q169 0 84.5 84.5Q0 169 0 288V1120Q0 1239 84.5 1323.5Q169 1408 288 1408H1120Q1239 1408 1323.5 1323.5Q1408 1239 1408 1120Z"
	})
});
export default SvgCheckBoxOutlineBlank;
